import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PlantStatusLayer from "../components/PlantStatusLayer";

const PlantStatusPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle='Asset Status Page'>
        {/* PlantStatusLayer */}
        <PlantStatusLayer />
      </MasterLayout>
    </>
  );
};

export default PlantStatusPage;